// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"ImageEditor_cursorPointer_1USMv","cursorGrab":"ImageEditor_cursorGrab_125PT","cursorGrabbing":"ImageEditor_cursorGrabbing_3EGph"};